import { render, staticRenderFns } from "./CheckoutPage.vue?vue&type=template&id=32aa31ea&scoped=true"
import script from "./CheckoutPage.vue?vue&type=script&setup=true&lang=ts"
export * from "./CheckoutPage.vue?vue&type=script&setup=true&lang=ts"
import style0 from "./CheckoutPage.vue?vue&type=style&index=0&id=32aa31ea&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "32aa31ea",
  null
  
)

export default component.exports